import { ref, computed } from '@vue/composition-api'
import { apiToastSuccess } from '@/@core/utils/toast'
import { formatObject, removeHtmlTags } from '@/@core/utils/utils'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import store from '@/store'
import { SEND_BROADCAST_MAIL } from '@/store/modules/notification.module'

export function useSendWishlistNotification(retailerEmailRef) {
  const subject = ref('')
  const message = ref('')
  const isLoading = ref(false)
  const showExpandedView = ref(false)
  const showForm = ref(true)

  const validateInput = computed(() => {
    const isValid = !(subject.value.length < 5) && !hasValidMessage.value
    return isValid
  })

  const hasValidMessage = computed(
    () => removeHtmlTags(message.value).length < 20,
  )

  function sendBroadcastMessage(hideModalFn) {
    isLoading.value = true
    const payload = {
      subject: subject.value,
      message: message.value,
      recipients: {
        additionalEmails: [retailerEmailRef.value],
      },
    }
    store
      .dispatch(SEND_BROADCAST_MAIL, payload)
      .then(res => {
        isLoading.value = false
        apiToastSuccess(res.data.message)
        analytics.track(
          constants.TRACKS.ACTIONS.BRAND_SEND_MESSAGE,
          formatObject({
            subject: subject.value,
            message: removeHtmlTags(message.value),
            recipientList: retailerEmailRef.value,
            entryPoint: 'Wishlist',
          }),
        )
        hideModalFn()
      })
      .catch(() => {
        isLoading.value = false
      })
  }

  function resetForm() {
    subject.value = ''
    message.value = ''
    showForm.value = true
    isLoading.value = false
  }

  function cancelNotification(hideModalFn) {
    analytics.track(
      constants.TRACKS.ACTIONS.BRAND_CANCELS_SENDING_MESSAGE,
      formatObject({
        subject: subject.value,
        message: removeHtmlTags(message.value),
        recipientList: retailerEmailRef.value,
        entryPoint: 'Wishlist',
      }),
    )
    hideModalFn()
  }

  return {
    subject,
    message,
    isLoading,
    showExpandedView,
    showForm,
    validateInput,
    hasValidMessage,
    sendBroadcastMessage,
    resetForm,
    cancelNotification,
  }
}
